import React from 'react';
import { PopUpRegisterForm } from '../../Molecules/PopUpRegisterForm/PopUpRegisterForm';
import { SimpleModalLT } from '../../Modals/SimpleModalLT/SimpleModalLT';
import './RegisterPopUp.css';

export const RegisterPopUp = ({
  strategicLine = {},
  setLoader = () => {},
  comeFromSM,
  openPopUp = false,
  additionalProduct,
  afterRegistration = () => {},
  showRegisterModal = false,
  headerPopUp,
  parameters,
  language = {},
  colorText = false
}) => {
  const modalBody =
    openPopUp && Object.keys(parameters).length > 0 ? (
      <div className="popup__body">
        <div className="title-section" style={{ width: '100%', textAlign: 'center' }}>
          <p style={{ color: 'var(--corporative-yellow)', fontSize: '42px' }}>{headerPopUp}</p>
          <p style={{ fontSize: '42px' }}>{strategicLine?.name}</p>
          {additionalProduct !== 0 && (
            <p>
              <strong style={{ color: 'var(--corporative-yellow)' }}>
                {parameters?.INF_MSG_47?.value || 'GRATIS:'}
              </strong>
              {additionalProduct}
            </p>
          )}
        </div>
        <PopUpRegisterForm
          interestData={strategicLine}
          afterRegister={afterRegistration}
          setLoader={setLoader}
          parameters={parameters}
          language={language}
          colorText={colorText}
        />
      </div>
    ) : (
      <></>
    );
  return (
    <SimpleModalLT
      className="popup-modal"
      show={openPopUp}
      hiddenHeader
      title=""
      message={modalBody}
      mayClose={!comeFromSM}
      showTitle={false}
      showFooter={false}
      backdrop={true}
      parameters={parameters}
      size="lg"
      closeModal={() => {
        afterRegistration();
        document.getElementsByTagName('html')[0].style.overflowY = 'scroll';
      }}
    />
  );
};
